export const editors = {};

export function get(editorName) {
    if (editors[editorName]) return editors[editorName];
}
//# sourceMappingURL=editors.js.map